// Map initialization for transport routes and stops
import L from "leaflet";
import "leaflet/dist/leaflet.css";

// Fix Leaflet's default icon path issue
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl:
    "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
});

// Decode Google Polyline Encoding to coordinates
// Based on https://developers.google.com/maps/documentation/utilities/polylinealgorithm
function decodePolyline(encoded) {
  if (!encoded) return [];

  const poly = [];
  let index = 0,
    len = encoded.length;
  let lat = 0,
    lng = 0;

  while (index < len) {
    let b,
      shift = 0,
      result = 0;
    do {
      b = encoded.charCodeAt(index++) - 63;
      result |= (b & 0x1f) << shift;
      shift += 5;
    } while (b >= 0x20);
    const dlat = result & 1 ? ~(result >> 1) : result >> 1;
    lat += dlat;

    shift = 0;
    result = 0;
    do {
      b = encoded.charCodeAt(index++) - 63;
      result |= (b & 0x1f) << shift;
      shift += 5;
    } while (b >= 0x20);
    const dlng = result & 1 ? ~(result >> 1) : result >> 1;
    lng += dlng;

    poly.push([lat / 1e5, lng / 1e5]);
  }

  return poly;
}

function initializeMaps() {
  console.log("Initializing maps...");

  // Find all map containers
  const mapContainers = document.querySelectorAll("[data-map-container]");

  if (mapContainers.length === 0) {
    console.log("No map containers found");
    return;
  }

  mapContainers.forEach((container) => {
    console.log("Initializing map for container:", container);

    // Get data attributes
    const polylineData = container.getAttribute("data-map-polyline");
    const stopsData = container.getAttribute("data-map-stops");
    const centerData = container.getAttribute("data-map-center");
    const zoomData = container.getAttribute("data-map-zoom");

    console.log("Polyline data (raw):", polylineData);
    console.log("Stops data (raw):", stopsData);
    console.log("Center data:", centerData);
    console.log("Zoom data:", zoomData);

    // Default to Uman coordinates
    let center = [48.7503, 30.2231];
    let zoom = 13;

    if (centerData) {
      try {
        center = JSON.parse(centerData);
      } catch (e) {
        console.error("Error parsing center data:", e);
      }
    }

    if (zoomData) {
      zoom = parseInt(zoomData);
    }

    // Initialize map
    const map = L.map(container).setView(center, zoom);

    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution:
        '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      maxZoom: 19,
    }).addTo(map);

    // Render polyline if present
    if (polylineData) {
      try {
        console.log("Attempting to decode polyline data...");

        // Try to parse as JSON first (array of coordinates)
        let coordinates;
        try {
          coordinates = JSON.parse(polylineData);
          console.log("Parsed as JSON coordinates:", coordinates);
        } catch (e) {
          // If JSON parse fails, treat it as encoded polyline string
          console.log("Not JSON, decoding as Google Polyline encoding...");
          coordinates = decodePolyline(polylineData);
          console.log("Decoded polyline coordinates:", coordinates);
        }

        console.log("Coordinates type:", typeof coordinates);
        console.log("Is array?", Array.isArray(coordinates));

        if (coordinates && coordinates.length > 0) {
          console.log("First coordinate:", coordinates[0]);
          console.log("Total points:", coordinates.length);

          const polyline = L.polyline(coordinates, {
            color: "blue",
            weight: 4,
            opacity: 0.7,
          }).addTo(map);

          map.fitBounds(polyline.getBounds());
          console.log("✓ Polyline rendered with", coordinates.length, "points");
        } else {
          console.log("⚠ Coordinates array is empty");
        }
      } catch (error) {
        console.error("✗ Error processing polyline:", error);
      }
    } else {
      console.log("⚠ No polyline data found");
    }

    // Render stops if present
    if (stopsData) {
      try {
        const stops = JSON.parse(stopsData);
        if (stops && stops.length > 0) {
          stops.forEach((stop) => {
            if (stop.lat && stop.lon) {
              const marker = L.marker([stop.lat, stop.lon]).addTo(map);

              if (stop.name) {
                marker.bindPopup(`<strong>${stop.name}</strong>`);
              }
            }
          });
          console.log("Rendered", stops.length, "stop markers");
        }
      } catch (error) {
        console.error("Error parsing stops:", error);
      }
    }

    // Invalidate size after a short delay to ensure proper rendering
    setTimeout(() => {
      map.invalidateSize();
    }, 100);
  });
}

// Support both Turbo (modern) and Turbolinks (legacy)
document.addEventListener("turbo:load", initializeMaps);
document.addEventListener("turbolinks:load", initializeMaps);
document.addEventListener("DOMContentLoaded", initializeMaps);

console.log("Map script loaded");
